import React, { useEffect, useState } from "react";
import Search from "../search/Search";

window.xs_toggleSearch = function() {
    window.dispatchEvent(new CustomEvent('xs_toggleSearch'));
}

export default function SearchToggle() {
    const [toggled, setToggled] = useState(false);

    function toggle() {
        setToggled(prev => !prev);
    }

    useEffect(() => {
        window.addEventListener('xs_toggleSearch', toggle);

        return () => window.removeEventListener('xs_toggleSearch', toggle);
    }, []);

    
    return (
        <>
            {toggled &&
                <Search toggle={toggle} />
            }
        </>
    );
}
